import { useContext } from 'react';
import { ChatbotContext } from '../contexts/chatbot-context';
import i18n from '../i18n';

const useLanguage = () => {
  const [state, setState] = useContext(ChatbotContext);

  const setLanguage = async (language) => {


    // we also save the language to the userStorage so we can use it in Axios
    localStorage.setItem('x-language', language);
    await i18n.changeLanguage(language);

    setState((currentState) => ({
      ...currentState,
      language
    }));
  };

  return {
    language: state.language,
    setLanguage
  };
};

export default useLanguage;
